<template>
  <div>
    <div v-if="!item.children || item.children.length == 0">
      <app-link :to="url">
        <iw-menu-item :index="`${item.id}`">
          <span slot="title" :title="item.title">{{ item.title }}</span>
        </iw-menu-item>
      </app-link>
    </div>
    <iw-submenu v-else :index="`${item.id}`">
      <template slot="title">
        <span>{{ item.title }}</span>
      </template>
      <SidebarItem
        v-for="child in item.children"
        :key="`${child.id}`"
        :item="child"
        :public-path="publicPath"
      />
    </iw-submenu>
  </div>
</template>

<script>
import SidebarItem from "./SidebarItem";
import AppLink from "./link";
import { isExternal } from "@/utils/validate";

export default {
  name: "SidebarItem",
  components: {
    SidebarItem,
    AppLink
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    publicPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    url() {
      const path = this.item.path;
      if (isExternal(path)) {
        return path;
      }
      let publicPath = this.publicPath;

      // 如果菜单中多加了publicPath则不加publicPath
      publicPath = path.indexOf(publicPath) === 0 ? "" : publicPath;

      // 如果菜单中含有reports-public则不加publicPath
      publicPath = path.indexOf("/reports-public") > -1 ? "" : publicPath;

      const url = `${publicPath}${path}`;
      return url;
    }
  },
  methods: {}
};
</script>
